import { styled } from "styled-components";
const SelectListOuter = styled("div")({
  alignItems: "stretch",
  flexBasis: "auto",
  flexDirection: "column",
  flexGrow: 0,
  flexShrink: 1,
  overflow: "auto",
  scrollbarWidth: "none",
  position: "relative"
});
const SelectListInner = styled("div")(
  {
    padding: "4px 0"
  },
  ({ $fadeTop }) => $fadeTop ? {
    "&::before": {
      content: JSON.stringify(""),
      display: "block",
      height: 32,
      marginTop: -32,
      pointerEvents: "none",
      position: "sticky",
      top: 0,
      background: `linear-gradient(
              to bottom,
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 0)
            )`
    }
  } : void 0,
  ({ $fadeBottom }) => $fadeBottom ? {
    "&::after": {
      content: JSON.stringify(""),
      display: "block",
      height: 32,
      marginTop: -32,
      pointerEvents: "none",
      position: "sticky",
      bottom: 0,
      background: `linear-gradient(
              to top,
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 0)
            )`
    }
  } : void 0
);
export {
  SelectListInner,
  SelectListOuter
};
